/**
 * @author SwathiDivya Bhavaraju
 * @email SwathiDivya.Bhavaraju@ul.com
 * @create date 2019-08-08 14:45:11
 * @modify date 2019-08-08 14:45:11
 * @desc [description]
 */
import axios from 'axios';

/**
 * getUpcomingRegistrations get api
 * to get the Upcoming Registrations based on accountId */
export async function getUpcomingRegistrations(accountId) {
  let registrations = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/dashboard/upcoming/widget/${accountId}`)
    .then((response) => {
      if (response.data.data) {
        registrations = response.data.data;
      }
    })
    .catch((err) => {
      console.log('upcoming/widget java api error', err); // eslint-disable-line no-console
    });
  return registrations;
}

/**
 * getDashboardSummary get api
 * to get the expiration and pending details */
export async function getDashboardSummary() {
  let dashboardSummary = {};
  await axios
    .get(`${process.env.VUE_APP_PYTHON_API_URL}/dashboard_summary`)
    .then((response) => {
      dashboardSummary = response.data;
    })
    .catch((err) => {
      console.log('dashboard_summary python api error', err); // eslint-disable-line no-console
    });
  return dashboardSummary;
}

/**
 * regulatoryheadlines get api
 *  is to get all the regualtory headlines */
export async function getRegulatoryHeadlines(type) {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines/${type}/metadata`;
  await axios
    .get(url)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('get regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getMainHeadlines() {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`;
  await axios
    .get(url)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('get regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getCurrentFeaturedContents() {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/featured/content`;
  await axios
    .get(url)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('get regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getAllFeaturedContent() {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/featured/content/all`;
  await axios
    .get(url)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('get regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function updateFeatureContent(data) {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/featured/content`;
  await axios
    .put(url, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('put regulatoryhealdines java api error', err); // eslint-disable-line no-console
      result = err.response.data;
    });
  return result;
}
/**
 * regulatoryheadlines post api
 *  is to add new regualtory headlines */
export async function addMainRegulatoryheadline(formData) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`;
  let result;
  await axios
    .post(url, formData)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('add regulatoryheadlines java api error', err); // eslint-disable-line no-console
      result = err.response.data;
    });
  return result;
}
export async function updateMainHeadline(data) {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`;
  await axios
    .put(url, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('put regulatoryhealdines java api error', err); // eslint-disable-line no-console
      result = err.response.data;
    });
  return result;
}
export async function addFeatureRegulatoryheadline(formData) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/featured/content`;
  let result;
  await axios
    .post(url, formData)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('add regulatoryheadlines java api error', err); // eslint-disable-line no-console
      result = err.response.data;
    });
  return result;
}

/**
 * regulatoryheadlines delete api
 * is to soft delete the regualtory headline */
export async function deleteHeadline(body) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/headlines`;
  let result;
  await axios
    .delete(url, { data: body })
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('delete regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function deleteFeaureHeadline(body) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/featured/content`;
  let result;
  await axios
    .delete(url, { data: body })
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('delete regulatoryheadlines java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * rams_tour get api
 * is to get is new user or not to show the tour popup */
export async function getRamsTour() {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/rams_tour`;
  await axios
    .get(url)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('get rams tour java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * rams_tour put api
 * is to update that user has seen or skipped the tour to db */
export async function updateRamsTour(data) {
  let result;
  const url = `${process.env.VUE_APP_JAVA_API_URL}/rams_tour`;
  await axios
    .put(url, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('put rams tour java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function postSupportForm(file, payLoad) {
  let result;
  const formData = new FormData();
  formData.append('supportFormData', new Blob([JSON.stringify(payLoad)], { type: 'application/json' }));
  formData.append('attachment', file);
  const url = `${process.env.VUE_APP_JAVA_API_URL}/dashboard/support/form`;
  await axios
    .post(url, formData)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('post support form api error', err); // eslint-disable-line no-console
    });
  return result;
}
